export class LLVideo {
	/**
	 * Init the class
	 *
	 * @param {HTMLElement} rootEl    The root element of the block
	 * @param {HTMLElement} rootClass The root class of the block
	 */
	constructor(rootEl, rootClass) {
        window.addEventListener("load", () => {

            const handler = (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !entry.target.classList.contains('loaded')) {
                        const videoContainer = rootEl.querySelector('.video-banner-file')
                        if(videoContainer) {
                            const file = videoContainer.dataset.file,
                                video = videoContainer.querySelector('video'),
                                source = document.createElement('source')

                            source.src = file
                            source.setAttribute('type', 'video/mp4')
                            video.appendChild(source)
                        }

                        rootEl.classList.add('loaded')
                    }
                });
            };
            const options = {
                root: null,
                threshold: 0,
            };

            const observer = new window.IntersectionObserver(handler, options);

            observer.observe(rootEl)
        })
	}
}
